import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ProfileView from "../profileDetails/ProfileView";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function PublicProfileView() {
  const { token } = useParams();
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
fetch(`/api/profile-share/shared-profile/${token}`)
      .then(res => {
        if (!res.ok) throw new Error("Link expired or invalid");
        return res.json();
      })
      .then(data => setProfile(data))
      .catch(err => setError(err.message));
  }, [token]);

  if (error) {
    return (
      <Box sx={{ p: 5, textAlign: "center" }}>
        <Typography variant="h5" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  if (!profile) {
    return (
      <Box sx={{ p: 5, textAlign: "center" }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
   <ProfileView profileData={profile} publicView={true} />
    </Box>
  );
}

export default PublicProfileView;